import React from 'react';

import { useVirtualizer } from '@tanstack/react-virtual';

import {
  MultiAutocompleteControl,
  useMultiAutocomplete,
  VirtualizedMenu,
} from '@adsk/alloy-react-dropdown';

import { FilterOption } from '../../types';

export interface VirtualFilterProps {
  options: FilterOption[];
  placeholder?: string;
  value?: unknown[];
  onChange?: (value: FilterOption[]) => void;
  isLoading?: boolean;
  isOpen?: boolean;
}

const VirtualFilter = ({
  options,
  placeholder,
  value,
  onChange,
  isLoading,
  isOpen,
}: VirtualFilterProps) => {
  const selectedOptions =
    value &&
    options.filter((option) => value.some((val) => option.value === val));

  const { controlProps, menuProps, virtualProps } = useMultiAutocomplete({
    initialIsOpen: isOpen,
    items: options,
    selectedItems: selectedOptions,
    onSelectedItemsChange: (changes) => {
      onChange?.(changes?.selectedItems || []);
    },
  });

  const { getTotalSize, getVirtualItems } = useVirtualizer(virtualProps);
  const { selectedItems } = menuProps;
  const selectedItemsSize = selectedItems?.length || 0;

  return (
    <>
      <MultiAutocompleteControl
        {...controlProps}
        isLoading={isLoading}
        placeholder={placeholder}
      />

      <VirtualizedMenu
        {...menuProps}
        setScrollElement={virtualProps.setScrollElement}
        totalSize={getTotalSize()}
        virtualItems={getVirtualItems()}
        renderFooter={selectedItemsSize ? undefined : () => null}
      />
    </>
  );
};

VirtualFilter.displayName = 'SubmittalsVirtualFilter';
VirtualFilter.defaultProps = {
  value: [],
  isLoading: false,
  isOpen: false,
  options: [],
  placeholder: 'Select',
};

export default VirtualFilter;
